import { getProfile, Profile } from '@creditsights/api-ui-web';
import { useQuery, UseQueryResult } from 'react-query';
import { queryKeys } from '../queryKeyFactory';

export default (enabled: boolean = true): UseQueryResult<Profile, Error> => {
  return useQuery<Profile, Error>([queryKeys.fetchProfile], () => getProfile(), {
    cacheTime: Infinity,
    enabled,
  });
};
